import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(tab-layout)/components/TeamNavigationEditButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/layout/NavBackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","TabBarTab"] */ "/app/webapp/app/pwa/components/TabBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamName"] */ "/app/webapp/app/pwa/components/team/TeamName.tsx");
